import React, { useContext } from 'react';
import { ActiveDatabaseContext } from '../../ActiveDatabaseContext/ActiveDatabaseContext';
import { IRutinerProps } from './AvailableRutinerInDelsystem';

const AvailableStyrvardenInDelsystem: React.FunctionComponent<
  IRutinerProps
> = props => {
  const activeDatabaseContext = useContext(ActiveDatabaseContext);
  if (!activeDatabaseContext.availableDelsystem) {
    return props.children([]);
  }

  return props.children(
    props.delsystem.styrvarden.filter(
      rutin => activeDatabaseContext.availableRoutines?.[rutin.rutinID]
    )
  );
};

export default AvailableStyrvardenInDelsystem;
